module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6a18aad7"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/module/main/App.vue
// module id = 214
// module chunks = 1